import React from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';

export const Thumb = ({ index, src, isVideo, setSelectedImage, selected, remainingQuantity, handleClick, alt }) => (
  <Container
    src={src}
    onMouseOver={selectedImage(setSelectedImage, index)}
    onFocus={selectedImage(setSelectedImage, index)}
    onClick={handleClick}
    selected={selected}
  >
    <ThumbImage src={src} alt={alt} />
    {isVideo && <Icon fill="#999999" />}

    <OpenModal visible={remainingQuantity} onClick={handleClick}>
      +{remainingQuantity}
    </OpenModal>
  </Container>
);

export const selectedImage = (setSelectedImage, index) => () => setSelectedImage(index);

const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75px;
  height: 66px;
  position: relative;
  cursor: pointer;
  border-radius: 3px;
  margin-right: 10px;
  padding: 0;
  border: 1px solid ${({ selected, theme }) => (selected ? theme.grey.dark : theme.grey.light)};
`;

const OpenModal = styled.div`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  color: #fff;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.45);
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
`;

const ThumbImage = styled.img`
  width: 70px;
  height: 64px;
  border-radius: 3px;
`;

export default Thumb;
